import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
}

export const NameField = ({
  placeholder,
  readOnly = false,
  disabled = false,
}: Props) => {
  return (
    <Form.Field name="name" readOnly={readOnly} disabled={disabled}>
      <Form.Label className="font-medium text-black">이름</Form.Label>
      <Form.TextField
        type="text"
        placeholder={placeholder || '이름을 입력해 주세요'}
        fullWidth
        readOnly={readOnly}
      />
      <Form.Message />
    </Form.Field>
  )
}
